<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-invoice-general-invoice-detail">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">{{ getTitle() }}</h1>

            <div class="col-sm-8 col-md-8 col-lg-8 pull-right">
              <div class="form-group">
                <label class="col-sm-8 col-md-8 col-lg-8 control-label">{{$t('invoice_general_invoice.checkin_datetime_feture')}}</label>
                <b class="col-sm-4 col-md-4 col-lg-4">
                  {{checkin_datetime_feture}}
                </b>
              </div>
            </div>
            <div class="col-sm-8 col-md-8 col-lg-8 pull-right">
              <div class="form-group">
                <label class="col-sm-8 col-md-8 col-lg-8 control-label">{{$t('invoice_general_invoice.apartment_code')}}</label>
                <b class="col-sm-4 col-md-4 col-lg-4">
                  {{apartment_code}}
                </b>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row">
                <div
                  class="col-sm-6 col-md-6 col-lg-6"
                  v-if="this.invoice_general_invoice_id == 0 ? false : true"
                >
                  <!-- Code -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.code')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('invoice_general_invoice.code')"
                          v-model="code"
                          class="form-control"
                          disabled
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- customer -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.customer')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('invoice_general_invoice.customer')"
                          v-model="customer"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- purpose_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.purpose_name')"
                  >
                    <div class="form-group">
                      <select v-model="purpose" class="form-control" id="purpose" disabled>
                        <option
                          v-for="option in invoicePurposeText"
                          v-bind:value="option.id"
                          :key="option.id"
                        >{{ option.text }}</option>
                      </select>
                      <!-- <div>
                        <input :placeholder="$t('invoice_general_invoice.purpose_name')" v-model="purpose_name" class="form-control" />
                      </div>-->
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- correlation_key -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.correlation_key')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="
                            $t('invoice_general_invoice.correlation_key')
                          "
                          v-model="correlation_key"
                          class="form-control"
                          :disabled="correlation_key_enable"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- type_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.type_name')"
                  >
                    <div class="form-group">
                      <div>
                        <select v-model="type" class="form-control">
                          <option
                            v-for="payment in payments_list"
                            v-bind:value="payment.id"
                            :key="payment.id"
                          >{{ $t(payment.text) }}</option>
                        </select>
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- amount -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.amount')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :disabled="purpose == InvoicePurposeEnum.SERVICE_PAYMENT"
                          :placeholder="$t('invoice_general_invoice.amount')"
                          v-model="amount"
                          class="form-control"
                          @change="onFormatAmount"
                          v-on:keyup="onFormatAmount"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- record_date -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.record_date')"
                  >
                    <div class="form-group">
                      <date-picker :config="options" :value="record_date" v-model="record_date"></date-picker>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <!-- deposit_deadline read Only -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('invoice_general_invoice.deposit_deadline')"
                  >
                    <div class="form-group">
                      <date-picker
                        :config="options"
                        :value="deposit_deadline"
                        v-model="deposit_deadline"
                      ></date-picker>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <!-- address -->
              <b-form-group
                label-size="sm"
                label-for="input-sm"
                :label="$t('invoice_general_invoice.address')"
              >
                <div class="form-group">
                  <div>
                    <textarea
                      v-model="address"
                      :placeholder="$t('invoice_general_invoice.address')"
                      class="md-textarea form-control"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </b-form-group>
              <!-- description -->
              <b-form-group
                label-size="sm"
                label-for="input-sm"
                :label="$t('invoice_general_invoice.description')"
              >
                <div class="form-group">
                  <div>
                    <textarea
                      v-model="description"
                      :placeholder="$t('invoice_general_invoice.description')"
                      class="md-textarea form-control"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </b-form-group>
            </b-form>


            <div v-if="purpose == InvoicePurposeEnum.SERVICE_PAYMENT">
                <div class="col-xs-6">
                </div>
                <div class="col-xs-6">
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12">
                    <div class="table-responsive customer-info">
                      <table class="table">
                        <tbody>
                          <tr>
                            <th style="width:16%">{{$t('apartmentbookings.services')}}:</th>
                            <td style="width:35%">
                            <select
                              class="form-control"
                              style="width:100%"
                               v-model="service_selected" 
                            >
                              <option
                                v-for="option in services"
                                v-bind:value="option.id"
                                :key="option.id"
                              >{{option.name}}</option>
                            </select></td>
                            <td style="width:25%"><button
                              class="btn btn-info"
                              @click="onAddInvoiceGeneralService()"
                            >
                              <i class="glyphicon glyphicon-plus"></i>
                              {{ $t(`common.add`) }}
                            </button></td>
                          </tr>
                      </tbody></table>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th style="width: 5%;">{{$t('common.nonumber')}}</th>
                          <th style="width: 25%;">{{$t('apartmentbookings.basicService.service')}}</th>
                          <th style="width: 15%;">Số Lượng</th>
                          <th style="width: 15%;">Đơn Giá</th>
                          <th style="width: 25%;" class="text-center">T.Tiền</th>
                          <th style="width: 5%;" class="text-center">Thao Tác</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for=" (item, index) in invoice_general_service" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{$t(`${item.service.name}`)}}</td>
                          <td><input class="form-control basic-input" v-model="item.quantity" @change="onChangeUnitPrice(item)" v-on:keyup="onChangeUnitPrice(item)"></td>
                          <td><input class="form-control basic-input" v-model="item.unit_price" @change="onChangeUnitPrice(item)" v-on:keyup="onChangeUnitPrice(item)"></td>
                          <td class="text-center">{{formatNumber(item.price)}}</td>
                          <td class="text-center"><button type="button" class="btn btn-sm btn-warning" @click="onRemoveGeneralService(item, index)"><i class="fa fa-trash"></i></button></td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
              <div class="col-xs-12">
                <hr>
              </div>

          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="editOrAddInvoiceGeneralInvoiceDetail(null)"
              :class="'btn btn-primary btn-sm pull-right'"
            >{{ $t("common.save") }}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{ $t("common.back") }}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal fade" id="modal-confirm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">
              {{
              typeUpdate == null
              ? $t("invoice_general_invoice.confirm_checkin")
              : typeUpdate == "check_out"
              ? $t("invoice_general_invoice.checkout")
              : $t("invoice_general_invoice.cancelled_room")
              }}
            </h1>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              @click="editOrAddInvoiceGeneralInvoiceDetail(typeUpdate)"
              class="btn btn-primary btn-sm pull-right"
            >Xác Nhận</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeConfirmModal"
            >{{ $t("common.back") }}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'
import i18n from "../lang";
import constantsData from "@/lib/constantsData";

const InvoicePurposeEnum = {
  BOOKING_DEPOSIT: 1,
  BOOKING_PAYMENTINADVANCE: 2,
  BOOKING_PAYMENT_DEPOSIT: 3,
  SERVICE_PAYMENT: 4
}

export default {
  name: "lte-modal",
  props: {
    type_booking: {
      type: String,
      default: () => {
        return 'normal'
      }
    },
  },
  data() {
    return {
      id: "",
      code: "",
      customer: "",
      address: "",
      description: "",
      amount: "",
      type_name: "",
      purpose: InvoicePurposeEnum.BOOKING_DEPOSIT,
      purpose_name: "",
      correlation_key: "",
      correlation_key_enable: true,
      user_created_full_name: "",
      type: 1,
      record_date: new Date(),//moment(new Date()).format("DD-MM-YYYY"), //utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      deposit_deadline: utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      booking_code: 0,
      checkin_datetime_feture: utils.addTimeZoneForTimestamp(new Date(), "DD/MM/YYYY"),
      apartment_code: "",

      options: {
        format: "DD/MM/YYYY",
        useCurrent: true
      },

      payments_list: constantsData.paymentsType,

      invoice_general_invoice_id: null,
      typeUpdate: null,

      callBackFrom: "",

      InvoicePurposeEnum: InvoicePurposeEnum,
      invoicePurposeText: [
        { id: InvoicePurposeEnum.BOOKING_DEPOSIT, text: 'invoice_purpose.booking_deposit' },
        { id: InvoicePurposeEnum.BOOKING_PAYMENTINADVANCE, text: 'invoice_purpose.booking_paymentinadvance' },
        { id: InvoicePurposeEnum.BOOKING_PAYMENT_DEPOSIT, text: 'invoice_purpose.booking_payment_deposit' },
        { id: InvoicePurposeEnum.SERVICE_PAYMENT, text: 'invoice_purpose.service_payment' }
      ],

      // basicServices: {
      //   selectedService: 1,
      //   options: constantsData.basicServices
      // },

      services: {},
      service_selected: 0,

      invoice_general_service: [],
      feeGroup: 2
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    onFormatAmount() {
      this.amount = utils.formatNumber(utils.formatInteger(this.amount.toString()))
    },
    onChangeUnitPrice: function (item) {
      item['price'] = Math.round((item['quantity'] * item['unit_price']))
      this.setTotalAmountForPurpose4()
    },
    onRemoveGeneralService: function(item, index) {
      this.invoice_general_service.splice(index, 1)
      this.setTotalAmountForPurpose4()
    },
    formatNumber: function (n) {
      if ((n !== null) || (n !== 0)) {
        return utils.formatNumber(n)
      }
      return 0
    },
    onAddInvoiceGeneralService: function () {
      let service_selected = this.services.filter(x=>x.id == this.service_selected)
      let service = {
          id: service_selected[0].id,
          name: service_selected[0].name
        }
      let item = {
        general_invoice: this.invoice_general_invoice_id,
        service: service,
        quantity: 0,
        unit_price: 0,
        price: 0
      }
      this.invoice_general_service.push(item)
      this.setTotalAmountForPurpose4()
    },

    setTotalAmountForPurpose4: function() {
      let amount = 0
      this.invoice_general_service.forEach( v => {
        amount += v.price
      })
      this.amount = amount
      this.onFormatAmount()
    },
    getTitle() {
      return this.invoice_general_invoice_id == 0
        ? this.$t("invoice_general_invoice.add")
        : this.$t("invoice_general_invoice.update");
    },
    // with from
    //INVOICE_GENERAL_INVOICE
    // BOOKING
    setCallBackFrom(from) {
      this.callBackFrom = from;
    },
    setValueDefault(object_data_default) {
      this.purpose = object_data_default.purpose;
      this.customer = object_data_default.customer;
      this.description = object_data_default.description;
      this.amount = object_data_default.amount;
      this.correlation_key = object_data_default.correlation_key;

      this.deposit_deadline = object_data_default.deposit_deadline;
      this.booking_code = object_data_default.booking_code;
      this.setEditCorrelationKey(true);
    },

    setEditCorrelationKey(val) {
      this.correlation_key_enable = val;
    },

    getCheckinDatetime(booking_code){
      if (booking_code != 0) {
        this.GET_BOOKING_DETAIL_BY_BOOKING_CODE({
          booking_code: booking_code
        }).then(
          function(res) {
            let booking_data = res.data;
            this.checkin_datetime_feture = utils.addTimeZoneForTimestamp(booking_data.checkin_datetime, 'DD/MM/YYYY')
            this.apartment_code = booking_data.apartment_mapping_with_booking_ids[0].apartment_details.apartment_code
          }.bind(this)
        );
      }
    },

    async submit(invoice_general_invoice_id) {
      this.invoice_general_invoice_id = invoice_general_invoice_id;

      // set empty when change invoice_general_invoice_id
      this.checkin_datetime_feture = ""
      this.apartment_code = ""

      if (
        invoice_general_invoice_id != null &&
        invoice_general_invoice_id != 0
      ) {
        this.GET_INVOICE_GENERAL_INVOICE_DETAIL({
          id: invoice_general_invoice_id
        })
          .then(
            function(res) {
              let data = res.data;

              this.id = data.id;
              this.type = data.type;
              this.purpose = data.purpose;
              this.code = data.code;
              this.customer = data.customer;
              this.address = data.address;
              this.description = data.description;
              this.amount = data.amount;
              this.type_name = data.type_name;
              this.purpose_name = data.purpose_name;
              this.correlation_key = data.correlation_key;
              this.user_created_full_name = utils.getFullName(
                data.user_created_first_name,
                data.user_created_last_name,
                i18n.locale
              );
              if(data.record_date != null){
                this.record_date = utils.addTimeZoneForTimestamp(data.record_date, "DD/MM/YYYY");
              }

              this.getCheckinDatetime(this.correlation_key)

              this.invoice_general_service = data.invoice_general_service

              $("#modal-invoice-general-invoice-detail").modal("show");
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ERROR_TOAST();
            }.bind(this)
          );
      } else {
        this.getCheckinDatetime(this.booking_code)
        $("#modal-invoice-general-invoice-detail").modal("show");
      }
    },
    editOrAddInvoiceGeneralInvoiceDetail: function(status_booking) {
      let data = {
        id: this.invoice_general_invoice_id,
        amount: utils.formatInteger(this.amount.toString()),
        customer: this.customer,
        address: this.address,
        description: this.description,
        correlation_key: this.correlation_key,
        purpose: this.purpose,
        type: this.type,
        user_created: this.GET_ACCOUNT_DATA.id,
        record_date: utils.formatSqlDate(this.record_date,"DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        invoice_general_service : this.invoice_general_service,
        type_booking: this.type_booking
      };

      if (this.invoice_general_invoice_id == 0) {
        this.ADD_INVOICE_GENERAL_INVOICE({
          id: this.invoice_general_invoice_id,
          ...data
        })
          .then(
            function(res) {
              // Update success
              $("#modal-invoice-general-invoice-detail").modal("hide");
              this.SUCCESS_TOAST();
              // this.$emit("callbackGetLeaseBackAvailableApartment");
              this.$emit("callbackInvoiceGeneralInvoiceSuccess");
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.UPDATE_INVOICE_GENERAL_INVOICE({
          id: this.invoice_general_invoice_id,
          ...data
        })
          .then(
            function(res) {
              // Update success
              $("#modal-invoice-general-invoice-detail").modal("hide");
              this.SUCCESS_TOAST();
              // this.$emit("callbackGetLeaseBackAvailableApartment");
              this.$emit("callbackInvoiceGeneralInvoiceSuccess");
            }.bind(this)
          )
          .catch(
            function(error) {
              $("#modal-invoice-general-invoice-detail").modal("hide");
              $("#modal-confirm").modal("hide");
              this.disabledCheckin = true;
              let error_data = error.response.data;
              if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "checkout_late"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checkout_time"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "invalid_checkin_time"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checkin_time"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "checked_out"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_checked_out"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "cancelled_room"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t(
                    "invoice_general_invoice.invalid_cancelled_room"
                  ),
                  styleType: "danger"
                });
              } else if (
                !utils.isNull(error_data.error_code) &&
                error_data.error_code == "cannot_checkout"
              ) {
                this.ON_SHOW_TOAST({
                  message: this.$t("invoice_general_invoice.cannot_check_out"),
                  styleType: "danger"
                });
              } else {
                // Show error toast
                this.ERROR_TOAST();
              }
            }.bind(this)
          );
      }
    },
    onShowModalConfirm: function(type) {
      this.typeUpdate = type;
      $("#modal-confirm").modal("show");
    },
    updateDateCheckinCheckout: function() {
      this.disabledCheckin = false;
    },
    closeModal: function() {
      $("#modal-invoice-general-invoice-detail").modal("hide");
      this.disabledCheckin = true;
    },
    closeConfirmModal: function() {
      $("#modal-confirm").modal("hide");
    },
    getServicesByGroup: function(feegroup) {
      const data = {
        params: {
          feegroup: feegroup
        }
      }
      this.GET_SERVICES_BY_GROUP(data).then(
        function(res){
          let data = res.data
          let services = []
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              price: v.service_fee[0].fee_value ? v.service_fee[0].fee_value : 0,
              vat: v.vat ? v.vat : 0,
              feegroup: v.feegroup,
              service_type: v.service_type,
              isChecked: false
            }
            services.push(item)
          })

          this.service_selected = services[0].id
          this.services = services
        }.bind(this)
      )
    },
    ...mapActions([
      "GET_INVOICE_GENERAL_INVOICE_DETAIL",
      "ADD_INVOICE_GENERAL_INVOICE",
      "UPDATE_INVOICE_GENERAL_INVOICE",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_BOOKING_DETAIL_BY_BOOKING_CODE",
      "GET_SERVICES_BY_GROUP"
    ])
  },
  mounted() {
    this.getServicesByGroup(this.feeGroup)
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}

#modal-invoice-general-invoice-detail .modal-dialog {
        width: 1024px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/LTEModalInvoiceGeneralInvoiceDetail.vue